import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../config/abilityContext';

const useManageInsurancePolicy = () => {
  const ability = useAbility(AbilityContext);
  return ability.can('manage', 'InsurancePolicy');
};

export default useManageInsurancePolicy;
